import React from 'react';
import { Card, CardContent, CardHeader } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import classes from './style.module.css';
import chrome from '../../../assets/images/chrome_icon.png'

const useStyles = makeStyles({
    blue: {
        color: '#3f50b5'
    },
    green: {
        color: "#4caf50",
        fontSize: 15,
    },
    grey: {
        color: "#666"
    },
    bgDanger: {
        background: "#f00",
        color: "#fff",
        fontSize: 15,
    },
    bgGrey: {
        background: "#f9f1c9",
        color: "#8a6d3b",
        fontSize: 15,
    },
    wn: {
        fontSize: 17
    }

});

const gotoLink = () => {
    const url = "https://chrome.google.com/webstore/detail/tmail-for-podio/nbonnidamdbokahofcindhjengelpnmc";
    window.open(url, '_blank', 'noopener,noreferrer');
}

const ExtensionCard = (props) => {
    const muClasses = useStyles();
    return (
        <Card variant="outlined" elevation={2} className={classes.cardClass} style={{ padding: 20, }} >
            <CardHeader title={props.title} className={muClasses.grey} />

            <CardContent >
                <div className={classes.multi}>
                    <img src={chrome} alt="chromeLogo" />
                </div>
                <div className={classes.multiBtm}>
                    <p className={classes.multiLink} onClick={gotoLink}>Install For Chrome</p>
                </div>
            </CardContent>
        </Card>
    )
}

export default ExtensionCard